import type { TTEObject } from '@timeedit/types';
import type { EditableTableProps } from '@timeedit/ui-components';
import { Collapse } from '@timeedit/ui-components/antd';
import type { TObjectPreviewFilterState } from './ObjectPreviewFilter';
import { ObjectsPreviewTable } from './ObjectPreviewTable';
import './ObjectPreviewCard.scss';

type TObjectsPreviewCardProps = {
  queries: Record<string, unknown>;
  showLinkToObject: boolean;
  title: string;
  footer?: React.ReactNode[];
  rowSelection?: EditableTableProps['rowSelection'];
  showTotalNumber?: boolean;
  virtualOptions?: {
    enable?: boolean;
    limitPerPage?: number;
    itemHeight?: number;
    listHeight?: number;
  };
  onObjectsChange?: (objects: TTEObject[]) => void;
  filter?: TObjectPreviewFilterState;
  onFilterChange?: (value: TObjectPreviewFilterState) => void;
};

export const ObjectsPreviewCard = ({
  title,
  queries,
  showLinkToObject = false,
  footer,
  rowSelection,
  virtualOptions,
  showTotalNumber,
  onObjectsChange,
  filter,
  onFilterChange,
}: TObjectsPreviewCardProps) => {
  return (
    <div className="objects-preview-card">
      <Collapse
        accordion
        defaultActiveKey={['object-preview-card']}
        items={[
          {
            key: 'object-preview-card',
            label: <span className="object-preview-title">{title}</span>,
            children: (
              <ObjectsPreviewTable
                queries={queries}
                showLinkToObject={showLinkToObject}
                footer={footer}
                rowSelection={rowSelection}
                virtualOptions={virtualOptions}
                showTotalNumber={showTotalNumber}
                onObjectsChange={onObjectsChange}
                filter={filter}
                onFilterChange={onFilterChange}
              />
            ),
          },
        ]}
      />
    </div>
  );
};
